import { routes } from 'routes/routes';
import { Empty, Icon, Link } from 'ui';

type P = {
  isFiltered: boolean;
};

const VideoListEmptyState = ({ isFiltered }: P) => {
  if (isFiltered) {
    return (
      <Empty
        description={{
          subtitle: 'Try adjusting your search or filters',
          title: 'No videos found',
        }}
        image={<Icon icon="search-2-line" />}
      />
    );
  }

  return (
    <Empty
      description={{
        subtitle: 'Your videos will appear here',
        title: 'No videos yet',
      }}
      image={<Icon icon="video-line" />}
    >
      <Link icon={<Icon icon="compass-line" />} to={routes.channels.index}>
        Go to channels
      </Link>
    </Empty>
  );
};

export default VideoListEmptyState;
